import { render, staticRenderFns } from "./BaseBackToTopButton.vue?vue&type=template&id=002abe26&scoped=true&"
import script from "./BaseBackToTopButton.vue?vue&type=script&lang=js&"
export * from "./BaseBackToTopButton.vue?vue&type=script&lang=js&"
import style0 from "./BaseBackToTopButton.vue?vue&type=style&index=0&id=002abe26&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002abe26",
  null
  
)

export default component.exports